export const EVENT_ORIENTATION_CHANGE = 'event_orientationchange';
export const EVENT_WINDOW_RESIZE = 'event_window_resize';

export const STATE_BEFORE_UPDATE = 'state_before_update';
export const STATE_AFTER_UPDATE = 'state_after_update';
export const STATE_BACK = 'state_back';
export const STATE_FOWARD = 'state_foward';
export const STATE_RESET = 'state_reset';
export const STATE_LOAD = 'state_load';


export const USER_FIRST_NAME = ' user_first_name';
export const USER_LAST_NAME = 'user_last_name';

export const VIDEO_PLAYER_READY = 'video_player_ready';

export const SCROLL_TEST = 'scroll_test';